import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import myVue from '@/main';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  key: 'taz.shipping',
  storage: window.localStorage
});

const ADD_SHIPPING_ITEM = 'ADD_SHIPPING_ITEM';
const REMOVE_SHIPPING_ITEM = 'REMOVE_SHIPPING_ITEM';
const FINALIZE_SHIPMENT = 'FINALIZE_SHIPMENT';

export default new Vuex.Store({
  plugins: [vuexLocal.plugin],
  state: {
    shippingItems: []
  },
  getters: {
    numberOfShippingItems(state) {
      return state.shippingItems.length;
    }
  },
  mutations: {
    [ADD_SHIPPING_ITEM](state, item) {
      if (state.shippingItems.find(f => f.id == item.id)) {
        return;
      }

      item.shippingStatus = 2;
      state.shippingItems.push(item);
    },
    [REMOVE_SHIPPING_ITEM](state, item) {
      let stateItem = state.shippingItems.find(f => f.id == item.id);
      let index = state.shippingItems.indexOf(stateItem);

      if (index > -1) {
        item.shippingStatus = 0;
        state.shippingItems.splice(index, 1);
      }
    },
    [FINALIZE_SHIPMENT](state) {
      state.shippingItems = [];
    }
  },
  actions: {
    [FINALIZE_SHIPMENT]({ commit }, lieferschein) {
      return myVue.$http
        .post('lieferschein', lieferschein)
        .then(resp => {
          commit(FINALIZE_SHIPMENT);
          return resp.data;
        })
        .catch(err => {
          console.error(err);
        });
    }
  }
});
